import {
  ChatBubbleIcon,
  LockClosedIcon,
  PlayIcon,
  RocketIcon,
  SketchLogoIcon,
} from "@radix-ui/react-icons";
import {
  BrainCogIcon,
  ChartCandlestickIcon,
  GemIcon,
  MessageSquareIcon,
  MessagesSquareIcon,
  PictureInPicture2Icon,
  PlaySquareIcon,
  UserCogIcon,
  WalletIcon,
} from "lucide-react";

export const routeOptions = [
  {
    route: "/",
    name: "Dashboard",
    icon: <PictureInPicture2Icon className="text-icon h-6 sm:h-5" />,
  },
  {
    route: "/maia",
    name: "MA.IA™",
    badge: "🔥 em alta",
    miniBadge: "🔥",
    icon: <BrainCogIcon className="text-icon h-6 sm:h-5" />,
  },
  // {
  //   route: "/learn",
  //   name: "Conteúdo",
  //   icon: <PlaySquareIcon className="text-icon h-6 sm:h-5" />,
  // },
  {
    route: "https://t.me/+FKhJWDwkixkwMTNh",
    route2: "https://t.me/+08Xx-lYIDSs1ZDE5",
    name: "Comunidade",
    icon: <MessagesSquareIcon className="text-icon h-6 sm:h-5" />,
    external: true,
  },
  {
    route: "/admin",
    name: "Admin",
    icon: <UserCogIcon className="text-icon h-6 sm:h-5" />,
    admin: true,
  },
  {
    route: "/admin/comments",
    name: "Comentários",
    icon: <MessageSquareIcon className="text-icon h-6 sm:h-5" />,
    admin: true,
  },
  // {
  //   route: "https://hotmart.com",
  //   name: "Indique e ganhe",
  //   icon: <GemIcon className="text-icon h-6 sm:h-5" />,
  //   external: true,
  // },
];

export const altRouteOptions = [
  {
    route: "/",
    name: "Dashboard",
    icon: <PictureInPicture2Icon className="text-icon h-6 sm:h-5" />,
  },
  {
    route: "?t=trades",
    icon: <ChartCandlestickIcon className="text-icon h-6 sm:h-5" />,
  },
  {
    route: "?t=wallet",
    icon: <WalletIcon className="text-icon h-6 sm:h-5" />,
  },
];

export const routeOptionsLatam = [
  {
    route: "/oportunidades",
    name: "Oportunidades",
    icon: <RocketIcon />,
  },
  {
    route: "/entrenamiento",
    name: "Ver entrenamiento",
    icon: <PlayIcon />,
  },
  {
    route: "",
    route2: "",
    name: "Comunidad",
    icon: <ChatBubbleIcon />,
    external: true,
  },
];
